module.exports = __webpack_public_path__ + "static/media/video.71a59fc3.svg";